import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import * as api from "helper/helper";
import "./productosTable.css";
import ClientesKPICalidadInformacion from "../Clientes/ClientesKPICalidadInformacion";
import { getMonthNames, getYearsUntilNow } from "helper/tools";

import { es } from "date-fns/locale";
import ClientesKPI from "../Clientes/ClientesKPI";
//import { format } from "date-fns";
import { useAuthStore } from "../../../../store/store";
import MarcasKPI from "../Clientes/MarcasKPI";
import ProductosNuevosSmall from "../Clientes/ProductosNuevosSmall";

/*
function SectionOption(id = "", title = "", isSelected = false) {
  this.id = id;
  this.title = title;
  this.isSelected = isSelected;
}*/

function ProductsDashboard({ subSectionId }) {
  const yearSelectRef = useRef();

  const [months, setMonths] = useState([]);

  const [years, setYears] = useState([]);
  const [yearSelected, setYearSelected] = useState(null);
  const [monthSelected, setMonthSelected] = useState(null);

  const fetchData = async (monthIndex, year) => {
    const start = new Date();
    start.setMonth(monthIndex);
    start.setDate(1);
    start.setFullYear(year);

    //const fechaInicial = format(start, "yyyy-MM-dd'T'00:00:00");

    useAuthStore.setState({ productoDashboadDate: start });
  };

  useEffect(() => {
    const date = new Date();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();

    setYearSelected(year);
    setMonthSelected(monthIndex);

    const wideMonthNames = getMonthNames(es).map((month, index) => ({
      name: month,
      isSelected: monthIndex === index,
    }));
    setMonths(wideMonthNames);

    const yearNames = getYearsUntilNow(es).map((year) => ({
      name: year,
      isSelected: false,
    }));
    setYears(yearNames);

    fetchData(monthIndex, date.getFullYear());
  }, []);

  return (
    <>
      <div className="separator"></div>

      <div
        className=""
        style={{
          display: "flex",
          alignItems: "center",
          columnGap: "10px",
          width: "310px",
        }}
      >
        {/*  <input ref={dateRangeEleRef} type="text" name="daterange" /> */}

        <select
          className="form-select"
          aria-label="Default select example"
          value={monthSelected}
          onChange={(item) => {
            const monthIndex = parseInt(item.currentTarget.value);
            setMonthSelected(monthIndex);
            fetchData(monthIndex, yearSelected);
          }}
        >
          {months.map((item, index) => {
            return (
              <option selected={item.isSelected} value={index}>
                {item.name}
              </option>
            );
          })}
        </select>

        <select
          className="form-select"
          aria-label="Default select example"
          value={yearSelected}
          onChange={(item) => {
            const year = parseInt(item.currentTarget.value);
            setYearSelected(item.currentTarget.value);
            //TODO  fetchData(monthIndex);
            yearSelectRef.current = year;
            //fetchData(monthIndex);

            fetchData(monthSelected, year);

            /*  reporteSmallRef.current.changeSelectedMonth(
                  monthSelectRef.current.value,
                  yearSelectRef.current,
                );*/
          }}
        >
          {years.map((item, index) => {
            return (
              <option selected={item.isSelected} value={item.name}>
                {item.name}
              </option>
            );
          })}
        </select>
      </div>

      <div className="bd-example">
        <div className="container  overflow-hidden">
          <div className="row  gx-5">
            <div className="col">
              <ProductosNuevosSmall />
            </div>

            <div
              className="col card1 recent-sales overflow-auto"
              style={{
                backgroundColor: "transparent",
                borderRadius: "0px",
                marginBottom: "30px",
              }}
            >
              <ClientesKPI />
              <MarcasKPI />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default React.memo(ProductsDashboard);
